module["exports"] = ["North", "East", "West", "South", "New", "Lake", "Port"];